import { HKAPI, HKPOSTAPI, HKPOSTTPAPI, HKYMAPI, HKYMPOSTAPI, HKPHPAPI, HKPHPPOSTAPI, HKZDYAPI, HKOCRAPI, HKPHPTPAPI,HKPOSTAPIWX } from "./common";
const commonAPI = { HKAPI, HKPOSTAPI, HKPOSTTPAPI, HKYMAPI, HKYMPOSTAPI, HKPHPAPI, HKPHPPOSTAPI, HKZDYAPI, HKOCRAPI, HKPHPTPAPI,HKPOSTAPIWX };
export { commonAPI };
